import React, { ComponentPropsWithoutRef } from 'react';
import { KeyboardInput } from '@rbx/ui';

type KeyboardInputProps = ComponentPropsWithoutRef<'kbd'>;

export default function MarkdownKeyboardInput(props: KeyboardInputProps) {
  return <KeyboardInput {...props} />;
}
